import { render } from "./MediaViewerComponent.vue?vue&type=template&id=06667f56&scoped=true&ts=true"
import script from "./MediaViewerComponent.vue?vue&type=script&lang=ts"
export * from "./MediaViewerComponent.vue?vue&type=script&lang=ts"

import "./MediaViewerComponent.vue?vue&type=style&index=0&id=06667f56&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06667f56"]])

export default __exports__